import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Http } from "@angular/http";
import { environment } from "../../environments/environment";

@Injectable()
export class AbstractLrmService {
  protected static endPointWs: string = environment.urlWs;

  //Create constructor to get Http instance
  constructor(protected http: Http) {}

  protected extractData(res: Response | any) {
    let body: any = res.json();
    return body;
  }

  protected handleError(error: Response | any) {
    return Observable.throw(error.status);
  }

  protected postRequest(endPoint: string, form: any): Observable<any> {
    return this.http
      .post(AbstractLrmService.endPointWs + endPoint, form)
      .map(this.extractData)
      .catch(this.handleError);
  }

  protected getRequest(endPoint: string): Observable<any> {
    return this.http
      .get(AbstractLrmService.endPointWs + endPoint)
      .map(this.extractData)
      .catch(this.handleError);
  }

  protected postRequestVoid(endPoint: string, form: any): Observable<any> {
    return this.http.post(AbstractLrmService.endPointWs + endPoint, form);
  }
}



// WEBPACK FOOTER //
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/common/abstractlrmService.ts